export default {
  title: "Bedrijven zoeken",
  name: {
    label: "Naam",
    placeholder: "Zoek op bedrijfsnaam",
  },
}
